module.exports = __webpack_public_path__ + "static/media/Inter-Black.661569af.woff2";